import { render, staticRenderFns } from "./EditingTemplateTranslation.vue?vue&type=template&id=30e9cb37&scoped=true&"
import script from "./EditingTemplateTranslation.vue?vue&type=script&lang=js&"
export * from "./EditingTemplateTranslation.vue?vue&type=script&lang=js&"
import style0 from "./EditingTemplateTranslation.vue?vue&type=style&index=0&id=30e9cb37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e9cb37",
  null
  
)

export default component.exports